<template>
  <div>
    <div class="stepContent">
      <el-row>
        <el-col :span="10">
          <el-row>
            <el-col :span="18">
              <ocf-workflow-info :data="dataForComponents.ocfWorkflowInfo"></ocf-workflow-info>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10">
          <use-finance-editor :options="optionsForComponents.useFinanceEditor" :data="dataForComponents.useFinanceEditor"
            @callback="onUseFinanceEditorCallback"></use-finance-editor>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-col :span="20">
        <hr>
      </el-col>
    </el-row>
    <el-row v-if="paymentMode == 0">
      <el-col>
        <payment-list-view :options="optionsForComponents.paymentListView" :data-list="dataForComponents.paymentListView"
          @item-click="onPaymentListViewItemClick" @item-remove="onPaymentListViewItemRemove"></payment-list-view>
      </el-col>
    </el-row>
    <!-- <el-row>
      <el-col>&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-select v-if="!isReadonly" v-model="paymentMode" size="medium" placeholder="请选择收费方式" :disabled="true" @change="onPaymentModeChange">
        <el-option v-for="item in paymentModes" :key="item.key" :label="item.value" :value="item.key">
        </el-option>
      </el-select>
      <span v-else>{{getPaymentModeText()}}</span>
    </el-row> -->
    <el-row>
      <el-col>&nbsp;</el-col>
    </el-row>
    <el-row v-if="paymentMode == 1">
      <autonomousPaymentSelector :excepts="[GLOBAL.enumPaymentType.emt, GLOBAL.enumPaymentType.creditCard]" :readonly="isReadonly" v-model="paymentType"
        @change="onPaymentTypeChange" />
    </el-row>
    <el-row v-if="isReadonly && paymentMode == 1 && !!paymentType && !!workflowData.QRCodeImage">
      <img :src="workflowData.QRCodeImage" />
    </el-row>
    <el-row v-if="paymentMode == 0">
      <el-col>
        <el-button v-if="!isReadonly" size="medium" :disabled="addPaymentBtnDisable" :type="addPaymentBtnClass" @click="showPaymentEditor">添加支付</el-button>
      </el-col>
    </el-row>
    <div class="stepFooter">
      <el-row class="cs-filter-row">
        <el-col>
          <el-button v-if="!isReadonly" size="medium" :disabled="submitBtnDisable" :type="submitBtnClass" @click="next">完成付款</el-button>
          <el-button size="medium" type="danger" @click="onRedoWorkflow">新建流程</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <payment-editor :account-id="dataForComponents.accountId" :options="optionsForComponents.paymentEditor" :data="dataForComponents.paymentEditor"
        :conditions="conditionsForComponents.paymentEditor" @closeDialog="onPaymentEditorClose" @callback="onPaymentEditorCallback"></payment-editor>
    </el-dialog>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="completedDialogVisible" top="3vh" class="completedMessage">
      <el-row>
        <el-col>
          <img src="../../../assets/success.png" />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span>收费成功</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="primary" @click="onCompletedDialogClose">完成</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.stepContent {
  padding: 20px 0px 0px 0px;
}

.stepFooter {
  .el-button {
    min-width: 98px;
  }
}

.completedMessage {
  .el-row {
    padding: 30px;

    .el-col {
      text-align: center;
    }
  }
}
</style>

<script>
import ocfWorkflowInfo from "./ocfWorkflowInfo";
import useFinanceEditor from "../../common/useFinanceEditor";
import paymentListView from "../../common/paymentListView";
import paymentEditor from "../../../components/common/paymentEditor";

import { getStudentMemberInfo } from "../../../service/student.service";
import {
  createAccountModel,
  createAccountPaymentModel,
} from "../../../service/finance.service.js";

export default {
  props: {
    data: {
      priceSettings: Object,
      bonusPointMechanisms: Object,
      bonusPointExchangeItems: Array,
      giftBalanceList: Array,
      otherCollectFeeTypes: Array,
      workflowData: Object,
      accountData: Object,
    },
  },
  data() {
    return {
      isReadonly: false,
      addPaymentBtnDisable: false,
      addPaymentBtnClass: "primary",
      submitBtnDisable: true,
      submitBtnClass: "primary",
      paymentEditorVisible: false,
      completedDialogVisible: false,
      priceSettings: null,
      bonusPointMechanisms: null,
      bonusPointExchangeItems: [],
      giftBalanceList: [],
      otherCollectFeeTypes: [],
      memberShipYears: [],
      workflowData: null,
      accountData: null,
      studentData: null,
      dataModel: {
        type: 0,
        feeYear: 0,
        subType: null,
        studentId: null,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        bonusPoint: 0,
        balance: 0,
        balanceDue: 0,
        balanceCost: 0,
        bonusPointCost: 0,
        bonusPointPrice: 0,
        bpeItemId: null,
        paymentCommissionCost: 0,
        paidCount: 0,
        paidAmount: 0,
        excessAmount: 0,
        cashDecreasedAmount: 0,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      },
      oldDataModel: null,
      optionsForComponents: {
        useFinanceEditor: {
          enableEdit: false,
        },
        paymentListView: {
          displayType: "normal",
          enableEdit: true,
          enableRemove: true,
        },
        paymentEditor: {
          showTitle: false,
          allowPaidCount: 0,
        },
      },
      dataForComponents: {
        accountId: 0,
        ocfWorkflowInfo: {
          priceSettings: null,
          bonusPointExchangeItems: [],
          giftBalanceList: [],
          otherCollectFeeTypes: [],
          memberShipYears: [],
          ocfType: 0,
          subType: null,
          studentId: null,
          phone: null,
          comment: null,
          amount: 0,
          feeYear: 0,
          quantity: 0,
          totalPrice: 0,
          paymentAmount: 0,
          balanceCost: 0,
          bonusPointCost: 0,
          bonusPointPrice: 0,
          bpeItemId: null,
          paidAmount: 0,
          excessAmount: 0,
          cashDecreasedAmount: 0,
          giftBalanceId: null,
          giftAmount: null,
          courseId: null,
        },
        useFinanceEditor: {
          bonusPointMechanisms: null,
          discounts: [],
          studentId: 0,
          phone: null,
          bonusPoint: 0,
          balance: 0,
          balanceDue: 0,
          paymentAmount: 0,
          oldBalanceCost: 0,
          oldBonusPointCost: 0,
          oldBonusPointPrice: 0,
          cashDecreasedAmount: 0,
          oldCashDecreasedAmount: 0,
        },
        paymentListView: [],
        paymentEditor: {
          index: -1,
          item: null,
        },
      },
      conditionsForComponents: {
        paymentEditor: {
          paidCount: 0,
          paymentAmount: 0,
        },
      },
      paymentModes: [
        { key: 0, value: "前台收费" },
        { key: 1, value: "学生自主缴费" },
      ],
      paymentMode: 0,
      paymentType: null,
    };
  },
  components: {
    ocfWorkflowInfo,
    useFinanceEditor,
    paymentListView,
    paymentEditor,
    autonomousPaymentSelector: () =>
      import("@/components/payApi/paymentSelector"),
  },
  computed: {
    isStudentTopUpBalance() {
      if (!this.USERMANAGER.isStudent) return false;
      return this.$route.name === "addCollectFeesTopUpBalance";
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    async loadStudentMemberInfoFromServer(
      studentId = !!this.workflowData ? this.workflowData.StudentId : null
    ) {
      if (!studentId) {
        this.studentData = null;
        return;
      }

      let result = await getStudentMemberInfo(studentId);
      if (!!result && result.success) this.studentData = result.data;
      else this.studentData = null;
    },
    loadDataFromProps(data = this.data) {
      if (!!data) {
        this.priceSettings = data.priceSettings;
        this.bonusPointMechanisms = data.bonusPointMechanisms;
        this.bonusPointExchangeItems = data.bonusPointExchangeItems;
        this.giftBalanceList = data.giftBalanceList;
        this.otherCollectFeeTypes = data.otherCollectFeeTypes;
        this.memberShipYears = data.memberShipYears;
        this.workflowData = $.extend(true, {}, data.workflowData);
        this.accountData = $.extend(true, {}, data.accountData);

        if (!this.workflowData.Id)
          this.workflowData.IsAutonomousPayment = this.isStudentTopUpBalance;
        this.paymentMode = this.workflowData.IsAutonomousPayment ? 1 : 0;
      } else {
        this.priceSettings = null;
        this.bonusPointMechanisms = null;
        this.bonusPointExchangeItems = [];
        this.giftBalanceList = [];
        this.otherCollectFeeTypes = [];
        this.memberShipYears = [];
        this.workflowData = null;
        this.accountData = createAccountModel();

        this.paymentMode = this.isStudentTopUpBalance ? 1 : 0;
      }
    },
    checkAllInputs(onlyCheck) {
      let isValid = true;

      if (
        this.dataModel.totalPrice -
          this.dataModel.cashDecreasedAmount -
          this.dataModel.balanceCost -
          this.dataModel.bonusPointPrice -
          this.dataModel.paidAmount +
          this.dataModel.excessAmount >
        0
      )
        isValid = false;

      if (!onlyCheck) {
        this.submitBtnDisable = !isValid;
        this.submitBtnClass = isValid ? "primary" : "info";

        let allowAddPayment =
          this.optionsForComponents.paymentEditor.allowPaidCount <= 0 ||
          this.dataModel.paidCount <
            this.optionsForComponents.paymentEditor.allowPaidCount;
        this.addPaymentBtnDisable = !allowAddPayment;
        this.addPaymentBtnClass = allowAddPayment ? "primary" : "info";
      }

      return isValid;
    },
    async initData(data = this.data) {
      this.loadDataFromProps(data);
      await this.loadStudentMemberInfoFromServer();
      this.reloadDataModel();
      this.reloadOptionsForAllComponents();
      this.reloadDataForAllComponents();
      this.reloadConditionsForAllComponents();
      this.checkAllInputs();
    },
    reloadDataModel() {
      if (!!this.workflowData) {
        this.isReadonly = this.workflowData.IsCompleted;
        this.dataModel.type = this.workflowData.Type;
        this.dataModel.feeYear = this.workflowData.FeeYear;
        this.dataModel.subType = this.workflowData.SubType;
        this.dataModel.studentId = this.workflowData.StudentId;
        this.dataModel.phone = this.workflowData.Phone;
        this.dataModel.comment = this.workflowData.Comment;
        this.dataModel.amount = this.workflowData.Amount;
        this.dataModel.quantity = this.workflowData.Quantity;
        this.dataModel.totalPrice = this.workflowData.TotalPrice;
        this.dataModel.balanceCost = this.workflowData.BalanceCost;
        this.dataModel.bonusPointCost = this.workflowData.BonusPointCost;
        this.dataModel.bonusPointPrice = this.workflowData.BonusPointPrice;
        this.dataModel.bpeItemId = this.workflowData.BonusPointExchangeItemId;
        this.dataModel.paymentCommissionCost =
          this.workflowData.PaymentCommissionCost;
        this.dataModel.cashDecreasedAmount =
          this.workflowData.CashDecreasedAmount;
        this.dataModel.giftBalanceId = this.workflowData.GiftBalanceId;
        this.dataModel.giftAmount = this.workflowData.GiftAmount;
        this.dataModel.courseId = this.workflowData.CourseId;
      } else {
        this.isReadonly = false;
        this.dataModel.type = 0;
        this.dataModel.feeYear = 0;
        this.dataModel.subType = null;
        this.dataModel.studentId = null;
        this.dataModel.phone = null;
        this.dataModel.comment = null;
        this.dataModel.amount = 0;
        this.dataModel.quantity = 0;
        this.dataModel.totalPrice = 0;
        this.dataModel.balanceCost = 0;
        this.dataModel.bonusPointCost = 0;
        this.dataModel.bonusPointPrice = 0;
        this.dataModel.bpeItemId = null;
        this.dataModel.paymentCommissionCost = 0;
        this.dataModel.cashDecreasedAmount = 0;
        this.dataModel.giftBalanceId = null;
        this.dataModel.giftAmount = null;
        this.dataModel.courseId = null;
      }

      this.dataModel.paidCount = this.__getPaidCount();
      this.dataModel.paidAmount = this.__getPaidAmount();
      this.calculateExcessAmount();

      if (!!this.studentData) {
        this.dataModel.bonusPoint = this.studentData.BonusPoint;
        this.dataModel.balance =
          this.studentData.Balance +
          this.studentData.NewBalance +
          this.studentData.GiftBalance;
        this.dataModel.balanceDue = this.studentData.BalanceDue;
      } else {
        this.dataModel.bonusPoint = 0;
        this.dataModel.balance = 0;
        this.dataModel.balanceDue = 0;
      }

      this.oldDataModel = $.extend(true, {}, this.dataModel);
    },
    reloadOptionsForAllComponents() {
      this.reloadOptionsForUseFinanceEditor();
      this.reloadOptionsForPaymentListView();
      this.reloadOptionsForPaymentEditor();
    },
    reloadOptionsForUseFinanceEditor() {
      let newOptions = {
        enableEdit: false,
      };

      newOptions.enableEdit =
        !this.isReadonly &&
        this.dataModel.type !=
          this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value &&
        this.dataModel.type !=
          this.GLOBAL.otherCollectFeeType.topUpBalance.value;

      this.optionsForComponents.useFinanceEditor = newOptions;
    },
    reloadOptionsForPaymentListView() {
      let newOptions = {
        displayType: "normal",
        enableEdit: true,
        enableRemove: true,
      };

      newOptions.enableEdit = !this.isReadonly;
      newOptions.enableRemove = !this.isReadonly;

      this.optionsForComponents.paymentListView = newOptions;
    },
    reloadOptionsForPaymentEditor() {
      let newOptions = {
        showTitle: true,
        allowPaidCount: 0,
      };

      this.optionsForComponents.paymentEditor = newOptions;
    },
    reloadDataForAllComponents() {
      this.dataForComponents.accountId = this.accountData.Id;
      this.reloadDataForOCFWorkflowInfo();
      this.reloadDataForUseFinanceEditor();
      this.reloadDataForPaymentListView();
    },
    reloadDataForOCFWorkflowInfo() {
      let newData = {
        priceSettings: null,
        bonusPointExchangeItems: [],
        giftBalanceList: [],
        otherCollectFeeTypes: [],
        memberShipYears: [],
        ocfType: 0,
        year: 0,
        subType: null,
        studentId: null,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        paymentAmount: 0,
        balanceCost: 0,
        bonusPointCost: 0,
        bonusPointPrice: 0,
        bpeItemId: null,
        paidAmount: 0,
        excessAmount: 0,
        cashDecreasedAmount: 0,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      };

      newData.priceSettings = this.priceSettings;
      newData.bonusPointExchangeItems = this.bonusPointExchangeItems;
      newData.giftBalanceList = this.giftBalanceList;
      newData.otherCollectFeeTypes = this.otherCollectFeeTypes;
      newData.memberShipYears = this.memberShipYears;
      newData.ocfType = this.dataModel.type;
      newData.feeYear = this.dataModel.feeYear;
      newData.subType = this.dataModel.subType;
      newData.studentId = this.dataModel.studentId;
      newData.phone = this.dataModel.phone;
      newData.comment = this.dataModel.comment;
      newData.amount = this.dataModel.amount;
      newData.quantity = this.dataModel.quantity;
      newData.totalPrice = this.dataModel.totalPrice;
      newData.paymentAmount = this.__getPaymentAmount();
      newData.balanceCost = this.dataModel.balanceCost;
      newData.bonusPointCost = this.dataModel.bonusPointCost;
      newData.bonusPointPrice = this.dataModel.bonusPointPrice;
      newData.bpeItemId = this.dataModel.bpeItemId;
      newData.paidAmount = this.dataModel.paidAmount;
      newData.excessAmount = this.dataModel.excessAmount;
      newData.cashDecreasedAmount = this.dataModel.cashDecreasedAmount;
      newData.giftBalanceId = this.dataModel.giftBalanceId;
      newData.giftAmount = this.dataModel.giftAmount;
      newData.courseId = this.dataModel.courseId;

      this.dataForComponents.ocfWorkflowInfo = newData;
    },
    reloadDataForUseFinanceEditor() {
      let newData = {
        bonusPointMechanisms: null,
        discounts: [],
        studentId: 0,
        phone: null,
        bonusPoint: 0,
        balance: 0,
        balanceDue: 0,
        paymentAmount: 0,
        oldBalanceCost: 0,
        oldBonusPointCost: 0,
        oldBonusPointPrice: 0,
        cashDecreasedAmount: 0,
        oldCashDecreasedAmount: 0,
      };

      let paymentAmount = this.__getPaymentAmount();
      paymentAmount += this.dataModel.paidAmount - this.dataModel.excessAmount;
      newData.bonusPointMechanisms = this.bonusPointMechanisms;
      newData.studentId = this.dataModel.type;
      newData.phone = this.dataModel.phone;
      newData.bonusPoint = this.dataModel.bonusPoint;
      newData.balance = this.dataModel.balance;
      newData.cashDecreasedAmount = this.dataModel.cashDecreasedAmount;
      newData.balanceDue = this.dataModel.balanceDue;
      newData.paymentAmount = paymentAmount;
      newData.oldBalanceCost = !this.isReadonly
        ? this.dataModel.balanceCost
        : 0;
      newData.oldBonusPointCost = !this.isReadonly
        ? this.dataModel.bonusPointCost
        : 0;
      newData.oldBonusPointPrice = !this.isReadonly
        ? this.dataModel.bonusPointPrice
        : 0;
      newData.oldCashDecreasedAmount = !this.isReadonly
        ? this.dataModel.cashDecreasedAmount
        : 0;

      this.dataForComponents.useFinanceEditor = newData;
    },
    reloadDataForPaymentListView() {
      let newData = [];

      newData = $.extend(true, [], this.accountData.AccountPayments);

      this.dataForComponents.paymentListView = newData;
    },
    reloadDataForPaymentEditor(index = -1, item = null) {
      let newData = {
        index: -1,
        item: null,
      };

      newData.index = index;
      newData.item = item;

      this.dataForComponents.paymentEditor = newData;
    },
    reloadConditionsForAllComponents() {
      this.reloadDataForOCFWorkflowInfo();
      this.reloadDataForUseFinanceEditor();
    },
    reloadConditionsForPaymentEditor(editAmount) {
      let newConditions = {
        paidCount: 0,
        paymentAmount: 0,
      };

      newConditions.paidCount = this.dataModel.paidCount;
      newConditions.paymentAmount = this.__getPaymentAmount(editAmount);

      this.conditionsForComponents.paymentEditor = newConditions;
    },
    calculateExcessAmount() {
      if (
        this.dataModel.paidAmount >
        this.dataModel.totalPrice -
          this.dataModel.cashDecreasedAmount -
          this.dataModel.balanceCost -
          this.dataModel.bonusPointPrice
      )
        this.dataModel.excessAmount =
          this.dataModel.paidAmount -
          (this.dataModel.totalPrice -
            this.dataModel.cashDecreasedAmount -
            this.dataModel.balanceCost -
            this.dataModel.bonusPointPrice);
      else this.dataModel.excessAmount = 0;
    },
    showPaymentEditor() {
      this.reloadDataForPaymentEditor();
      this.reloadConditionsForPaymentEditor();

      this.paymentEditorVisible = true;
    },
    next() {
      if (this.submitBtnDisable) return;
      this.submitBtnDisable = true;
      this.triggerNext();
    },
    showCompletedDialog() {
      this.completedDialogVisible = true;
    },
    onCompletedDialogClose() {
      this.completedDialogVisible = false;
    },
    onUseFinanceEditorCallback(dataOut) {
      if (!dataOut.success) return;

      let successMessage;
      switch (dataOut.data.type) {
        case 1:
          let balanceCost = dataOut.data.balanceCost;
          this.dataModel.balanceCost = balanceCost;
          successMessage = balanceCost > 0 ? "使用余额成功" : "重置余额成功";
          this.$message({
            message: successMessage,
            type: "success",
          });
          break;
        case 2:
          let bonusPointCost = dataOut.data.bonusPointCost;
          let bonusPointPrice = dataOut.data.bonusPointPrice;
          this.dataModel.bonusPointCost = bonusPointCost;
          this.dataModel.bonusPointPrice = bonusPointPrice;
          successMessage = bonusPointCost > 0 ? "使用积分成功" : "重置积分成功";
          this.$message({
            message: successMessage,
            type: "success",
          });
          break;
        case 3:
          this.dataModel.cashDecreasedAmount = dataOut.data.cashDecreasedAmount;

          successMessage =
            this.dataModel.cashDecreasedAmount > 0
              ? "使用现金减成功"
              : "重置现金减成功";
          this.$message({
            message: successMessage,
            type: "success",
          });
          break;
      }
      this.accountData.Amount =
        this.dataModel.amount -
        this.dataModel.balanceCost -
        this.dataModel.bonusPointPrice;
      this.calculateExcessAmount();
      this.reloadDataForAllComponents();
      this.checkAllInputs();
    },
    onPaymentListViewItemClick(dataOut) {
      this.reloadDataForPaymentEditor(dataOut.index, dataOut.item);
      this.reloadConditionsForPaymentEditor(dataOut.item.Amount);

      this.paymentEditorVisible = true;
    },
    async onPaymentListViewItemRemove(dataOut) {
      let confirmResult = false;
      await this.$confirm("是否删除该项支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          confirmResult = true;
        })
        .catch(() => {});
      if (!confirmResult) return;

      let payment =
        dataOut.index >= 0
          ? this.accountData.AccountPayments[dataOut.index]
          : null;
      if (!payment) return;

      if (payment.Id > 0) payment.Enable = false;
      else this.accountData.AccountPayments.splice(dataOut.index, 1);

      this.dataModel.paymentCommissionCost = this.__getPaidServiceCharge();
      this.dataModel.paidCount = this.__getPaidCount();
      this.dataModel.paidAmount = this.__getPaidAmount();

      this.calculateExcessAmount();
      this.reloadDataForAllComponents();
      this.checkAllInputs();
    },
    onPaymentEditorClose() {
      this.paymentEditorVisible = false;
      this.dataForComponents.paymentEditor = null;
    },
    onPaymentEditorCallback(dataOut) {
      let payment =
        dataOut.index >= 0
          ? this.accountData.AccountPayments[dataOut.index]
          : null;
      if (!!payment) {
        payment.PaymentTypeId = dataOut.data.PaymentTypeId;
        payment.ServiceCharge = dataOut.data.ServiceCharge;
        payment.Amount = dataOut.data.Amount;
        payment.Comment = dataOut.data.Comment;
        payment.IsMemberCard =
          this.dataModel.type ==
            this.GLOBAL.otherCollectFeeType.memberCard.value ||
          this.dataModel.type ==
            this.GLOBAL.otherCollectFeeType.renewMemberCard.value;
      } else this.accountData.AccountPayments.push(dataOut.data);

      this.dataModel.paymentCommissionCost = this.__getPaidServiceCharge();
      this.dataModel.paidCount = this.__getPaidCount();
      this.dataModel.paidAmount = this.__getPaidAmount();

      this.calculateExcessAmount();
      this.reloadDataForAllComponents();
      this.checkAllInputs();
    },
    getDataOut() {
      let result = {
        stepIndex: 1,
        data: this.dataModel,
        accountData: this.accountData,
      };

      return result;
    },
    hasDataChange() {
      let result =
        JSON.stringify(this.dataModel) != JSON.stringify(this.oldDataModel);
      return result;
    },
    triggerNext() {
      let dataOut = this.getDataOut();
      this.$emit("next", dataOut);
    },
    __getPaidCount(account = this.accountData) {
      if (!account) return 0;

      let result = 0;
      account.AccountPayments.forEach((item) => {
        if (!item.Enable) return;
        result += 1;
      });

      return result;
    },
    __getPaidAmount(account = this.accountData) {
      if (!account) return 0;

      let result = 0;
      account.AccountPayments.forEach((item) => {
        if (!item.Enable) return;
        result += item.Amount;
      });

      return result;
    },
    __getPaidServiceCharge(account = this.accountData) {
      if (!account) return 0;

      let result = 0;
      account.AccountPayments.forEach((item) => {
        if (!item.Enable) return;
        result += item.ServiceCharge;
      });

      return result;
    },
    __getPaymentAmount(editAmount) {
      let paidAmount = this.dataModel.paidAmount;
      if (!!editAmount) paidAmount -= editAmount;
      let result =
        this.dataModel.totalPrice -
        this.dataModel.cashDecreasedAmount -
        this.dataModel.balanceCost -
        this.dataModel.bonusPointPrice -
        paidAmount;
      if (result < 0) result = 0;

      return result;
    },
    onRedoWorkflow() {
      this.$router.replace(this.$route.name, { query: {} });
      this.$emit("reload");
    },
    getPaymentModeText() {
      let item = this.paymentModes.find((i) => i.key == this.paymentMode);
      if (item) {
        return item.value;
      }
      return "";
    },
    onPaymentModeChange() {
      if (this.paymentMode == 0) {
        this.workflowData.IsAutonomousPayment = false;
      } else {
        this.workflowData.IsAutonomousPayment = true;
      }
    },
    onPaymentTypeChange() {
      this.workflowData.PaymentType = this.paymentType;
    },
  },
  watch: {
    data: function (newVal) {
      this.initData(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/otherCollectFee/ocfWorkflowStep2.vue